import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FeatureFlag } from '@mode/shared/contract-common';
import { getInitialFlagValue, HelpDocsService } from '@mode/shared/util-js';

@Component({
  selector: 'mode-r-intro',
  templateUrl: './r-intro.component.html',
  styleUrl: './r-intro.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RIntroComponent {
  isRegisterImportedDatasetEnabled = getInitialFlagValue(FeatureFlag.RegisterImportedDatasetsNotebooks);
  @Output() toggle = new EventEmitter<string>();
  @Input() itemExpandedOrCollapsed!: Record<string, boolean>;

  @Output() goToSupportedLibraries = new EventEmitter<void>();
  @Output() goToKeyboardShortcuts = new EventEmitter<void>();

  constructor(public helpDocs: HelpDocsService) {}

  toggleSection(section: string) {
    this.toggle.emit(section);
  }

  isOpenSection(topic: string): boolean {
    return !!this.itemExpandedOrCollapsed[topic];
  }
}
